import { useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export interface UsageLogMetadata {
  [key: string]: any;
}

export const useUsageTracking = () => {
  const { user } = useAuth();

  const logUsage = useCallback(async (
    eventType: string,
    metadata: UsageLogMetadata = {},
    location?: string
  ) => {
    try {
      const { error } = await supabase
        .from('usage_logs')
        .insert({
          user_id: user?.id || null,
          event_type: eventType,
          metadata,
          location,
        });

      if (error) {
        console.error('Error logging usage:', error);
      }
    } catch (error) {
      console.error('Error logging usage:', error);
    }
  }, [user?.id]);

  return { logUsage };
};